import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSort, MatSortable, MatSortModule } from '@angular/material/sort';

import { TableHeaderComponent } from '@cure-components/table/components/table-header/table-header.component';

import { NoResultsComponent } from '../no-results/no-results.component';
import { ColumnType } from './table.interfaces';
import { TableCellComponent } from './components/table-cell/table-cell.component';

@Component({
  selector: 'app-table',
  standalone: true,
  imports: [
    MatTooltipModule,
    CommonModule,
    MatPaginatorModule,
    MatTableModule,
    NoResultsComponent,
    MatSortModule,
    MatProgressSpinnerModule,
    TableCellComponent,
    TableHeaderComponent,
  ],
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
})
export class TableComponent implements AfterViewInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  @Input() loading: boolean;
  @Input() hidePagination: boolean = false;
  @Input() rowClick: boolean = false;
  @Input() rowClassFn?: (row: any) => string | null;
  @Input({ required: true }) dataSource: MatTableDataSource<any>;

  @Input({ required: true }) get columns(): ColumnType[] {
    return this._columns;
  }

  set columns(columns: any[]) {
    this._columns = columns;
    this._displayedColumns = columns.map((column) => column.key);
  }

  @Output() pageChange = new EventEmitter<PageEvent>();
  @Output() onRowClick = new EventEmitter<any>();

  get showNoResults(): boolean {
    return !this.loading && !this.dataSource.data.length;
  }

  get showLoader(): boolean {
    return this.loading;
  }

  ngAfterViewInit() {
    this.paginator.page.subscribe((event) => {
      this.pageChange.emit(event);
    });
    this.dataSource.sort = this.sort;
  }

  protected _displayedColumns: string[] = [];
  protected _columns: ColumnType[];

  public setPaginatorLength(total: number) {
    if (this.paginator) {
      if (this.paginator.length !== total) {
        this.paginator.pageIndex = 0;
        this.paginator.length = total;
      }
    }
  }

  public setPagination(page: number, pageSize: number) {
    if (this.paginator) {
      this.paginator.pageIndex = page - 1;
      this.paginator.pageSize = pageSize;
    }
  }

  public setSort(sortable: MatSortable) {
    // reset sort
    this.sort.sort({ id: '', start: 'asc', disableClear: false });
    this.sort.sort(sortable);
  }

  protected handleRowClick(row: any) {
    if (this.rowClick) {
      this.onRowClick.emit(row);
    }
  }
}
